// removed by extract-text-webpack-plugin
module.exports = {"root":"ProfileSettingsPage__root__1i2kQ","content":"ProfileSettingsPage__content__2dEqB","desktopTopbar":"ProfileSettingsPage__desktopTopbar__2e2De","mobileTopbar":"ProfileSettingsPage__mobileTopbar__xzmxC","headingContainer":"ProfileSettingsPage__headingContainer__UznyL","heading":"ProfileSettingsPage__heading__3DLk1","profileLink":"ProfileSettingsPage__profileLink__2zgVR"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ProfileSettingsPage/ProfileSettingsPage.css
// module id = 2381
// module chunks = 0